export const S2S_ROUTE_NAMES = {
  S2S_DASHBOARD: 's2s-dashboard',
  S2S_PACKAGES: 's2s-packages',
};
